export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-sketch-98b82ad8da4518b38d1d2692aa233a1e.png";